// 
// index.js
// cenit-website
// 
// Created by Matías Martínez on 21/8/25
// 

import App from "./App";

const app = new App(document);
window.app = app;
